export default "__VITE_PUBLIC_ASSET__440fc264__"